import { globalVal } from './globalvalues';
export const seoData: any = {
    home: {
        title:`${globalVal && globalVal.long_name} | Activate lines, add new lines & manage data.`,
        description: `Experience convenience like never before - activate lines, add new lines & manage data with the best-in-class 5G network. Login, activate & enjoy!`,
        keywords: `${globalVal && globalVal.long_name} activation page, ${globalVal && globalVal.long_name} SIM activation, Add lines, Manage data, Activate SIM, Activate eSIM, best 4G/5G network, ${globalVal && globalVal.long_name} eSIM, Activation page, ${globalVal && globalVal.long_name} account activation`,
        canonicalUrl: `${process.env.REACT_APP_ENV}/post-activation-home`,
    },
    account: {
        title:`${globalVal && globalVal.long_name} - Manage account, plans & data on the go!`,
        description: `Effortlessly manage your ${globalVal && globalVal.long_name} account on the go - access plan details, enable or pause services, & track usage history for all lines. `,
        keywords: `"Account management, User profile, ${globalVal && globalVal.long_name} Plan details, Usage history, Account settings, Data usage, Account preferences, Manage subscriptions, ${globalVal && globalVal.long_name} Plan details, Enable plan, Pause plan, ${globalVal && globalVal.long_name}, Mobile Plan control, Usage tracking 
        "`,
        canonicalUrl: `${process.env.REACT_APP_ENV}/account`,
    },
    preLogin: {
        title: `${globalVal && globalVal.long_name} | Get Reliable service at affordable prices.`,
        description: `"Get on ${globalVal && globalVal.long_name} in 3 easy steps:
        Login, activate & enjoy! Experience best-in-class mobile service with unlimited voice & text, affordable plans & more."`,
        keywords: `Mobile service, mobile network, mobile plan, Activate, best 4G/5G mobile network, best 4G/5G phone network, best 4G/5G cell phone carrier, 4G/5G cell phone carrier, best 4G/5G cell phone deals, no contract, no contract phone carriers, best 4G/5G cell phone coverage,`,
        canonicalUrl: `${process.env.REACT_APP_ENV}/mobile-login`,
    },
    bestFit: {
        title: `Money saving plans | Best 5G network coverage - ${globalVal && globalVal.long_name}`,
        description: `Overpaying for unused data? Save up to $300 a year with a Best Fit™ plan from ${globalVal && globalVal.long_name}. Unlimited talk & text. Best 5G mobile coverage.`,
        keywords: `best fit, best fit plans, money saving plans, Unlimited talk and text, save money on phone bill, annual savings, best 5g mobile coverage, save upto $300, ${globalVal &&
            globalVal.long_name}.`,
    },
    gigsThatGive: {
        title: `No contract phone service with social impact - ${globalVal && globalVal.long_name}`,
        description: `Mobile plans starting @ just $20, where every plan helps connect someone in need. Unlimited talk and text on nation's largest 5G LTE network.`,
        keywords: `${globalVal &&
            globalVal.short_name} wireless, no contract phone service, largest 5G network, mobile plans, connect someone in need, ${globalVal && globalVal.long_name}, social impact, women empowernment,`,
    },
    billCalculator: {
        title: `Phone bill calculator | Compare phone plans - ${globalVal && globalVal.long_name}`,
        description: `Looking to switch mobile carriers? Use our phone bill calculator to compare phone plans and see how much you save when you switch to ${globalVal &&
            globalVal.long_name}.`,
        keywords: `phone bill calculator, compare phone plans, ${globalVal && globalVal.long_name}, switch mobile carriers, cell phone plan calculator, compare mobile plans,`,
    },
    aboutUs: {
        title: `About US - ${globalVal && globalVal.long_name}`,
        description: `${globalVal &&
            globalVal.long_name} is a socially conscious mobile service with the best mobile plans on the nation's most reliable 5G network. Great customer service 24/7.`,
        keywords: `${globalVal &&
            globalVal.long_name}, best mobile plans, reliable 5g network, great customer service,`,
    },
    imeiCompatibility: {
        title: `IMEI compatibility check- ${globalVal && globalVal.long_name}`,
        description: `Bring your phone to ${globalVal &&
            globalVal.long_name}. Check phone carrier compatibility with a mobile IMEI check. This lets you know right away if you can switch to ${globalVal &&
            globalVal.long_name}.`,
        keywords: `${globalVal &&
            globalVal.long_name}, imei compatibility check, check phone carrier, IMEI check, imei carrier check, imei info, device eligibility check.`,
    },
    cellPhonePlans: {
        title: `Best cell phone plans | No contract - ${globalVal && globalVal.long_name}`,
        description:
            'No-contract flexible cell phone plans starting @ $20. Unlimited talk and text. Fully digital mobile service on the largest 5G network.',
        keywords: `best cell phone plans, unlimited data plan, family mobile plans, check 5G coverage, no contract phone plans, international calling plans, reliable 5G network coverage, ${globalVal &&
            globalVal.long_name}.`,
    },
    internationalServices: {
        title: `Best International Roaming plans - ${globalVal && globalVal.long_name}`,
        description: `Traveling abroad? ${globalVal &&
            globalVal.long_name} offers stress-free International Roaming plans in 135+ countries. No daily fees. No per-country charges.`,
        keywords: `international roaming plans, international calling, ${globalVal &&
            globalVal.long_name}, international services.`,
    },
    contactUs: {
        title: `Contact Us - ${globalVal && globalVal.long_name}`,
        description: `Have questions about ${globalVal &&
            globalVal.long_name}'s plans or service? Call us or chat online with one of our friendly customer success reps.`,
        keywords: `${globalVal && globalVal.long_name}, help center, contact us, customer support.`,
    },
    reviews: {
        title: `Customer Reviews - ${globalVal && globalVal.long_name}`,
        description:
            'Great support, reliable service, and affordable! Their Best Fit feature to bill you for a cheaper plan when you use less data is a nice money-saver, too.',
        keywords: `${globalVal && globalVal.long_name} reviews, customer reviews, reliable service,`,
    },
    terms: {
        title: `Terms and conditions - ${globalVal && globalVal.long_name}`,
        description: `Terms of use. In order to protect ${globalVal &&
            globalVal.long_name} and its customers from fraudulent activity, we may implement reasonable procedures regarding any online orders.`,
        keywords: `terms and conditions, ${globalVal && globalVal.long_name}, terms of use.`,
    },
    feedback: {
        title: `Feedback - ${globalVal && globalVal.long_name}`,
        description: `How easy was it to buy your ${globalVal &&
            globalVal.long_name} plan? Your feedback means a lot to us and will help us improve the overall experience.`,
        keywords: `feedback, ${globalVal && globalVal.long_name}, customer experience.`,
    },
    discover: {
        title: `Discover best deals on devices and services - ${globalVal && globalVal.long_name}`,
        description: `Discover new and renewed unlocked devices, subscription services and other offers and deals in the Discover section of ${globalVal &&
            globalVal.long_name}.`,
        keywords: `renewed phones, unlocked devices, subscription services, best deals on phones, ${globalVal &&
            globalVal.long_name}.`,
    },
    help: {
        title: `${globalVal && globalVal.long_name} | Seeking help? Visit out 24X7 Support Center`,
        description: `Got questions? Get 24X7 assistance from our experts. Make the most of your services, get information about your account, and more! `,
        keywords: `${globalVal && globalVal.long_name}, Support Center, Help, Assistance, Questions, Experts, Services, Information, Customer Support, Get Help`,
        canonicalUrl: `${process.env.REACT_APP_ENV}/help`,
    },
    profile : {
        title: `${globalVal && globalVal.long_name} | Your profile `,
        description: `View or manage your profile details and find your billing details all in one place. Get reliable and affordable 4G/5G connectivity with ${globalVal && globalVal.long_name}.`,
        keywords: `${globalVal && globalVal.long_name}, Profile info, Account details, Billing information, Personal information, Registered email, Account number, 5G connectivity, Profile management, Account administration`,
        canonicalUrl: `${process.env.REACT_APP_ENV}/help`,
    },
    login: {
        title: `Sign in - ${globalVal && globalVal.long_name}`,
        description: `${globalVal && globalVal.long_name} offers the best 5G cell phone plans on the nation's largest, fastest and most reliable 5G network. Enjoy superior customer support 24/7.`,
        keywords: `best 5G mobile network, ${globalVal && globalVal.short_name} wireless, no contract phone service, largest 5G network, mobile plans, connect someone in need, ${globalVal && globalVal.long_name}, social impact, women empowernment, ${globalVal &&
            globalVal.long_name}.`,
    },
    services: {
        title:`${globalVal && globalVal.long_name} | Select & manage your mobile services`,
        description: `Embrace the ultimate 5G network services! Select & manage your International Roaming, International Calling & Domestic Roaming with ${globalVal && globalVal.long_name}! `,
        keywords: `Internation Roaming, International Calling, Domestic Roaming, 5G Network services, Global roaming services, Reliable network coverage, High-speed connectivity, ${globalVal && globalVal.long_name}, Services, Mobile services`,
        canonicalUrl: `${process.env.REACT_APP_ENV}/services`,
    },
    privacy: {
        title: `Privacy Policy - ${globalVal && globalVal.long_name}`,
        description: `The Privacy Policy describes how ${globalVal && globalVal.long_name} will collect, access, use, or disclose your personal information and applies to all of our products, services, applications, and websites.`,
        keywords: `Privacy Policy, ${globalVal && globalVal.long_name}`,
    },
    earthHome: {
        title: `Home-EarthLink `,
        // description: `Never overpay for data with ${globalVal &&
        //     globalVal.long_name}. No contracts, Flexible plans, Unlimited talk & text. Best cell phone coverage. Great customer service.`,
        // keywords: `best mobile network, best phone network, best cell phone carrier, cell phone carrier, best cell phone deals no contract, no contract phone carriers, best cell phone coverage,`,
    },
    earthAccount: {
        title: `Account-EarthLink`,
    },
    earthDevice: {
        title: `Device-EarthLink`,
    },
    earthHelp: {
        title: `Help-EarthLink`,
    },
    earthBilling: {
        title: `Billing-EarthLink`,
    },
    earthTracking: {
        title: `Tracking History-EarthLink`,
    },
    earthActivation: {
        title: `Activation-EarthLink`,
    },
    earthLogin: {
        title: `Login-EarthLink`,
    },
    earthSetup: {
        title: `Setup-EarthLink`,
    },
    manageCards: {
        title: `Manage Cards-EarthLink`,
    },
};
